import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const sandboxDetector: Example = {
  id: "sandbox-detector",
  title: "Sandbox detection",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "Checks for hooks, webdriver, descriptors, timing, and WebAssembly before reporting in",
  explainer:
    "Each check is an EVASION event: `toString` on `fetch`, `navigator.webdriver`, the `eval` " +
    "descriptor, a busy-wait timing loop, and `typeof WebAssembly`. Afterimage answers every one " +
    "like Chrome, so the script decides it's in a real browser and sends its beacon, and the " +
    "Report groups the checks into one sandbox-detection finding.",
  code,
  expect: golden as Example["expect"],
};
